import { NgModule } from '@angular/core';
import { SharedModule } from '../../../../../shared';
import { CrossSellPipeModule } from '../../pipes';

import { CrossSellBadgeComponent } from './cross-sell-badge.component';

@NgModule({
    imports: [
        SharedModule,
        CrossSellPipeModule
    ],
    declarations: [
        CrossSellBadgeComponent,
    ],
    exports: [
        CrossSellBadgeComponent,
    ]
})
export class CrossSellBadgeModule { }
